// THÊM NHANH TỪ MENU (pilot 03/09/2026) — mỗi mục menu có thể kèm một nút "+" căn phải:
//   • bấm CHÍNH MỤC  → mở DANH SÁCH (như xưa, không đổi gì)
//   • bấm NÚT "+"    → mở thẳng FORM THÊM của mục đó
//
// Tách RIÊNG thành module THUẦN (không import UI/DB) đúng nếp `visibility.ts` + `menu-theo-co.ts`:
// một nguồn sự thật cho CẢ HAI cửa menu (Sidebar desktop + drawer mobile dùng chung `NavGroups`),
// và test rà được không cần trình duyệt.
//
// ⛳ CẬP NHẬT 03/09/2026 — AN CHỐT CHO `/patients` VÀO SỚM, trước khi có ba số đo. Chữ ⛔ bên dưới
//    GIỮ NGUYÊN làm bối cảnh và vẫn đúng cho mọi route KHÁC. Vì sao ngoại lệ này an toàn: vé
//    `benh-nhan-danh-sach-rieng` chốt ràng buộc **form không đổi một dòng**, nên
//      ① "nhập liên tiếp" TỰ THOẢ — nút "Lưu bệnh nhân" của form là `form.reset()` + ở lại, form
//        không gọi `useKetThucForm` nên hộp KHÔNG đóng; đó chính là "Lưu & thêm tiếp" mà khỏi thêm nút;
//      ②③ đổi từ "đo trước" thành **nghiệm thu bắt buộc** (blueprint vé đó §1 R3);
//      "Quyên ngồi nhập thật" đổi thành **màn cũ `/patients-legacy` 7 ngày** — ai ngơ thì quay về.
//    Đọc đủ lý do ở docs/feature/benh-nhan-danh-sach-rieng.md §4. Đây là ngoại lệ CÓ TÊN, không phải
//    lời huỷ luật: mục thứ SÁU vẫn phải chờ ba số đo.
//
// ⛳ CẬP NHẬT 11/09/2026 — CỔNG ⛔ BÊN DƯỚI ĐÃ MỞ, và đây là lý do (chữ ⛔ giữ nguyên làm bối cảnh;
//    nó đúng suốt 03→10/09). Ba số đo §4 **đã đo thật** trên VM và An **đã đọc**, tức đủ CẢ HAI vế
//    của cổng ra đợt 1 (blueprint §3). Số nằm ở
//    docs/worklog/them-nhanh-tu-menu-worklog.md mục "11/09/2026 — BA SỐ ĐO §1". Tóm tắt đúng ba câu:
//      ① Hộp **không** làm chậm: form-trong-hộp ↔ form-trên-trang lệch 9 ms/bản ghi. Cái đắt là
//        ĐÓNG-MỞ mỗi lần (+1,55 s và +2 cú bấm) ⇒ màn nào nhập theo lô thì phải có nút "…& thêm
//        tiếp", đừng bỏ.
//      ② Cảnh báo mềm trong hộp **CÓ bệnh ở màn thấp** (600 px: băng bị cuộn khuất 100%). Chỉ dính
//        màn có `warnings` + form dài hơn hộp ⇒ **hai màn của đợt này KHÔNG dính** (không màn nào
//        có cảnh báo mềm), nhưng nợ đó vẫn treo cho `/appointments`.
//      ③ Nút phụ đi đích khác: gọi `router.push` RỒI `ketThuc.daLuu()` là **mất đích** (`replace`
//        của hộp đè lên). Luật: push thẳng, ĐỪNG gọi `daLuu` — trang đổi thì hộp tự rụng.
// ⛔ ĐỢT 1 ĐANG DỪNG Ở ĐÂY — 4 mục. **Đừng khai mục thứ 5** cho tới khi có ba số đo của
//    docs/feature/them-nhanh-tu-menu.md §4 (blueprint §1 nói đo Ở ĐÂU, bằng gì). Ba route của đợt 1
//    được chọn CHÍNH VÌ chúng làm ba câu đó đo được — khai thêm trước khi đọc số là bỏ lỡ đúng cái
//    mà đợt 1 sinh ra để lấy.
//    Riêng `/patients` phải là mục CUỐI CÙNG được khai: form bệnh nhân gánh dò-trùng + 3 nút submit
//    đi 3 đích + RBAC lồng 2 lớp, và là màn lễ tân gõ mỗi ngày (xem đầu `app/patients/NewPatientForm.tsx`).

/** Tên tham số URL bật chế độ "đang thêm". Trạng thái nằm ở URL, KHÔNG ở state — xem `dangMoThem`. */
export const THAM_SO_THEM = "them";

export type ThemNhanh = {
  /** Nhãn nút (chú giải chuột + máy đọc màn hình) — cũng dùng làm tiêu đề hộp thoại. */
  nhan: string;
  /** Quyền GHI mà server action của form đòi. Phải TRÙNG chuỗi trong `requirePermission(...)`. */
  quyen: string;
  /**
   * Route này **không có mục menu** ⇒ cố ý KHÔNG mọc nút `+`; hộp chỉ vào được từ nút đầu trang.
   *
   * 🩸 SINH RA TỪ MỘT MÂU THUẪN CÓ THẬT (14/09/2026), không phải để né lưới: sổ này đang gánh
   *    HAI việc khác nhau — ① khai `nhan`/`quyen` cho **hộp thêm** (`khaiThem` NÉM nếu trang bày
   *    hộp mà chưa khai, để không có hai nguồn sự thật) và ② khai route nào **mọc `+` trên menu**
   *    (lưới ③ ĐỎ nếu khai một href không phải mục menu). Hai việc ấy trùng nhau ở 7 route đầu nên
   *    không ai thấy vướng — tới `/inventory/items` (trang CON của mục "Kho & vật tư") thì hai vế
   *    chửi nhau: khai thì lưới ③ đỏ, không khai thì `khaiThem` ném.
   *    ⇒ Cờ này nói thẳng "biết là không có `+`, cố ý" — giữ nguyên việc của lưới ③ là bắt dòng
   *      khai **CHẾT VÌ QUÊN**, chỉ bỏ qua dòng khai chết **VÌ CHỦ ĐÍCH**.
   *    ⚠️ Đừng bật cờ này để cho lưới xanh. Route có mục menu mà `+` không hiện là **bọ**, không
   *      phải ngoại lệ.
   */
  ngoaiMenu?: boolean;
  /**
   * Route THÊM RIÊNG (`/xxx/new`) của mục menu này — có khoá này thì nút `+` trên menu trỏ thẳng tới
   * đây, KHÔNG trỏ `href?them=1`. Mục khai `dich` là mục **không có hộp** ⇒ `khaiThem` NÉM với nó.
   *
   * ⛳ THÊM 01/10/2026 (vé `nut-them-menu-marketing`, gói 1b audit cụm Marketing — Q-b = A). Đây
   *    chính là khoá tuỳ chọn mà "câu để ngỏ" 17/09 ở chú thích `duongDanThem` hẹn: hôm nay có màn
   *    hạng route-riêng **có mục menu** (Khuyến mãi · Voucher, form ra `/new` từ gói 1). Tên `dich`
   *    chứ không `href` như câu 17/09 gợi: `href` đã là KHOÁ của sổ (route danh sách) — hai thứ cùng
   *    tên là mời nhầm.
   *    ⚠️ Phải bắt đầu bằng `<href của mục>/` và trỏ một thư mục `app<dich>/page.tsx` có thật — lưới
   *       `test/menu-them-nhanh.test.tsx` ① canh cả hai.
   */
  dich?: string;
  /**
   * Quyền phải có THÊM ngoài `quyen` thì nút `+` mới hiện (đòi ĐỦ, không phải một trong).
   *
   * ⛳ THÊM 01/10/2026 (An chốt, feature `nut-them-menu-marketing` hộp ⛳ đầu tờ). `quyen` là quyền GHI của
   *    server action; nhưng trang đích có thể gác bằng quyền KHÁC. Ca thật: `/campaigns` — action đòi
   *    `crm:write`, trang gác `marketing:read`, menu hiện cho `any` của hai quyền ⇒ người chỉ có `crm:write`
   *    thấy `+`, bấm là bị `redirect("/")`. Khoá này nói "muốn mời bấm thì phải VÀO ĐƯỢC trang đích".
   *    Chỉ là phần NHÌN — rào thật vẫn ở cổng trang và `requirePermission()` của action.
   */
  quyenKem?: readonly string[];
};

export const THEM_NHANH: Record<string, ThemNhanh> = {
  "/referrers": { nhan: "Thêm người giới thiệu", quyen: "referrer:write" },
  // ── ĐỢT 1 (03/09/2026) — ba route chọn để ĐO ĐƯỢC ①②③ của feature §4, không phải chọn cho dễ:
  "/inventory/suppliers": { nhan: "Thêm nhà cung cấp", quyen: "inventory:write" }, // ca thử Q4 (<details>)
  "/appointments": { nhan: "Đặt lịch hẹn", quyen: "appointment:write" }, // có băng cảnh báo mềm ⇒ đo ②
  "/inventory/receive": { nhan: "Thêm phiếu nhập kho", quyen: "inventory:write" }, // nhập theo lô ⇒ đo ①③
  // ── ĐỢT 4 (03/09/2026) — An chốt vào sớm, xem hộp ⛳ đầu tệp. Quyền `patient:write` là lớp NGOÀI;
  //    nút thứ ba của form ("Lưu & khách ĐÃ ĐẾN") còn gác `appointment:write` BÊN TRONG form — hai
  //    lớp lồng nhau, đừng "gọn hoá" thành một.
  "/patients": { nhan: "Thêm bệnh nhân", quyen: "patient:write" },
  // ── ĐỢT 2 (11/09/2026) — An chốt sau khi đọc ba số đo (hộp ⛳ đầu tệp). Hai màn này KHÔNG nằm
  //    trong danh sách đợt 2 của blueprint §3 (`/inventory/issue` · `/inventory/counts` · `/lab`):
  //    `/lab` có, `/staff` thì đợt 1 đã GẠT ra vì tiêu chí *"không tiền"* (`StaffForm` có
  //    `baseSalary`). Tiêu chí đó sinh ra để **chọn màn ĐO**, không phải để cấm màn — số đã đo
  //    xong nên nó hết việc. Ô lương vẫn gác nguyên `payroll:read` như trước, hộp không đụng tới.
  "/lab": { nhan: "Đặt labo mới", quyen: "lab:write" },
  "/staff": { nhan: "Thêm nhân sự", quyen: "staff:write" },
  // ── 28/09/2026 (feature cum-nhan-su-luong-ve-chuan, luật ⑥) — form tạo kỳ rời trang danh sách.
  //    Mục menu ⇒ mọc `+` (không `ngoaiMenu`): tạo kỳ chỉ tháng một lần, nhưng tiền lệ `/staff` cũng
  //    thế — `+` là lối vào thứ hai, không phải lời hứa tần suất.
  "/payroll": { nhan: "Tạo kỳ lương", quyen: "payroll:write" },
  // Trang CON của mục KPI (không có mục menu riêng) ⇒ `ngoaiMenu`: hộp chỉ mở từ nút đầu trang.
  "/payroll/kpi-assistant/config": { nhan: "Thêm hạng mục", quyen: "payroll:write", ngoaiMenu: true },
  "/payroll/kpi-receptionist/config": { nhan: "Thêm hạng mục", quyen: "payroll:write", ngoaiMenu: true },
  // ── ĐỢT 3 (14/09/2026) — KHÔNG phải "nhân cho đủ màn", mà vì SỐ ĐO của vé
  //    `audit-ui-width-man-vat-tu`: Card "Thêm vật tư mới" đứng trên danh sách ăn **157px**, cộng
  //    CardHeader 65px ⇒ Ⓐ (đệm lạnh) = **637px = 102% cửa sổ 625** — mở `/inventory/items` ra
  //    KHÔNG THẤY MỘT DÒNG DỮ LIỆU NÀO, phải cuộn qua hết form mới tới danh mục 1.702 vật tư.
  //    Đối chứng: `/patients` (form đã vào hộp từ đợt 4) Ⓐ = 299px = 48%.
  //    Route CON của mục "Kho & vật tư" (`/inventory`) ⇒ `ngoaiMenu` — xem khối 🩸 ở khai báo kiểu.
  "/inventory/items": { nhan: "Thêm vật tư", quyen: "inventory:write", ngoaiMenu: true },
  // ⛳ 16/09/2026 — dòng khai `"/inventory/bundles"` (thêm sáng cùng ngày, `6f43fd59`) ĐÃ XOÁ khỏi
  //    sổ này: màn tháo, xem docs/feature/thao-man-goi-vat-tu.md.
  // ⛳ 16/09/2026 (cùng lượt, màn thứ hai) — `implants` là form **NHẬP THEO LÔ** (nhập một thùng trụ
  //    thì gõ liên tiếp nhiều serial). Nó ĐÃ `reset()` + ở lại và KHÔNG gọi `useKetThucForm` ⇒ trong
  //    hộp nó tự là "Lưu & thêm tiếp", đúng ngoại lệ có tên của `/patients` (hộp ⛳ 03/09 đầu tệp)
  //    và đúng vế ① của ba số đo 11/09. Không đổi một dòng hành vi của form.
  //    Trang CON ("Trụ Implant" ẩn khỏi sidebar từ 23/07 theo feedback Phương) ⇒ `ngoaiMenu`.
  "/inventory/implants": { nhan: "Thêm trụ implant", quyen: "inventory:write", ngoaiMenu: true },
  // ⛳ 16/09/2026 (đợt 1 cụm Kho — màn Kiểm kê) — `NewCountForm` SOI XONG theo feature §6/§6c:
  //    3 ô (chi nhánh · ngăn tích nhóm · ghi chú), **một bước**, không thêm-dòng động, không
  //    `warnings` ⇒ đúng hạng **hộp** của §1b ⑥ (≤7 trường, một bước), không phải hạng "route
  //    riêng" như `RequestForm`/`PurchaseOrderForm`.
  //    ⚖️ Và nó KHÔNG nhập theo lô: tạo xong là `router.push` sang `/inventory/counts/<id>` để đi
  //    nhập số đếm ⇒ trong hộp vẫn đúng một lần, **không** gọi `useKetThucForm().daLuu()` — đường
  //    đó làm `replace` của hộp đè lên đích vừa push (vế ③ của ba số đo 11/09, hộp ⛳ đầu tệp).
  //    Trang đổi thì hộp tự rụng.
  //    `/inventory/counts` CÓ mục menu ("Kiểm kê / Chốt kho") ⇒ **không** `ngoaiMenu`: nút `+` mọc
  //    trên menu, đúng luật ⑤.
  "/inventory/counts": { nhan: "Tạo phiên kiểm kê", quyen: "inventory:write" },
  // ⛳ 17/09/2026 (bước B của cụm Kho — màn Xuất / tiêu hao) — `IssueForm` là form cuối của cụm còn
  //    đứng inline trên trang danh sách. Số đo soi 16/09 (worklog cụm Kho, mục màn `issue`): **4 ô ·
  //    một bước · ~300px · không đa dòng** ⇒ đúng hạng HỘP của §1b ⑥, không phải hạng "route riêng"
  //    như `RequestForm`/`PurchaseOrderForm` (hai cái đó VẪN đang chờ An, đừng khai kèm).
  //    ⏳ Lượt 16/09 dừng vì form mở tiếp một `useConfirm` khi cổng soi trả `kq.hoi` ("âm kho" /
  //    "vừa bấm y hệt") ⇒ hộp-trong-hộp. Điều kiện đó GỠ ngày 17/09: `components/modal.tsx` giữ
  //    ngăn xếp cấp module, chỉ hộp ĐỈNH ăn Esc + khoá Tab (`3a3baa17`,
  //    docs/feature/hop-thoai-chong-lop.md). An chốt LÀM cùng ngày.
  //    ⚖️ Nhập theo lô: xuất hỏng/hủy thường đi một loạt vài món ⇒ form có nút "Xuất & thêm tiếp"
  //    qua `useKetThucForm` (nếp `ReceiveForm`), không bắt đóng-mở hộp mỗi món (+1,55s/bản ghi).
  //    `/inventory/issue` CÓ mục menu ("Xuất / tiêu hao") ⇒ **không** `ngoaiMenu`: nút `+` mọc trên
  //    menu, đúng luật ⑤.
  "/inventory/issue": { nhan: "Xuất kho thủ công", quyen: "inventory:write" },
  // ── 01/10/2026 (vé `nut-them-menu-marketing`, gói 1b audit cụm Marketing) — hai mục HẠNG ROUTE RIÊNG
  //    đầu tiên vào sổ: form 9 / 8 trường + khối phạm vi đã ra `/new` từ gói 1 (luật ⑥ §1b), không có
  //    hộp nào ⇒ khai `dich` (nút `+` trỏ thẳng `/new`), `khaiThem` sẽ NÉM nếu trang nào lỡ dựng hộp
  //    cho chúng. Quyền = chuỗi `requirePermission` của `createDiscount` / `createVoucher`
  //    (`app/marketing/actions.ts`). Mục menu ⇒ không `ngoaiMenu`: `+` là lối vào thứ hai, không phải
  //    lời hứa tần suất (tiền lệ `/payroll` 28/09).
  // ── 01/10/2026 (cùng vé, Đ2) — `/campaigns`: hộp tạo chiến dịch từng mở bằng `useState` cục bộ (không ở URL)
  //    ⇒ sang hộp chuẩn `?them=1`. Hạng HỘP (2 ô, một bước). Tạo xong `router.push` thẳng `/campaigns/<id>`,
  //    KHÔNG `daLuu` (vế ③ hộp ⛳ đầu tệp). Quyền = `requirePermission("crm:write")` của `createCampaign`.
  // ⛳ 01/10/2026 — `quyenKem`: trang `/campaigns` gác `marketing:read` (action gác `crm:write`) ⇒ `+` đòi cả hai.
  "/campaigns": { nhan: "Tạo chiến dịch", quyen: "crm:write", quyenKem: ["marketing:read"] },
  // ⛳ 01/10/2026 (vé `viec-goi-chien-dich-ve-chuan` Đ3, gói 3 audit cụm Marketing — Q1 = B) — hộp *Nhập khách*
  //    của trang CHI TIẾT chiến dịch: ô nhập hàng loạt ~330px luôn mở đẩy worklist khỏi màn ⇒ vào hộp `?them=1`.
  //    🔑 KHOÁ LÀ MẪU ROUTE (`[id]`, đúng tên thư mục `app/campaigns/[id]`), không phải một href thật: dòng này
  //       chỉ để `khaiThem` trả `nhan`/`quyen` cho HỘP (một nguồn sự thật), còn link mở hộp thì trang tự dựng
  //       bằng `duongDanThem("/campaigns/" + id, sp)`. Route động ⇒ không thể là mục menu ⇒ `ngoaiMenu`
  //       đúng nghĩa khối 🩸 ở khai báo kiểu (cố ý không có `+`), không phải để cho lưới ③ xanh.
  //    Quyền = `requirePermission("crm:write")` của `importContacts` (`app/campaigns/actions.ts`).
  //    Đã đo trước khi khai (blueprint §B/§F): mọi ca của `test/menu-them-nhanh.test.tsx` đọc sổ theo
  //    `Object.keys` đều nhận được khoá này (`ngoaiMenu` bỏ qua ca ③; `app/campaigns/[id]/page.tsx` có thật).
  "/campaigns/[id]": { nhan: "Nhập khách", quyen: "crm:write", ngoaiMenu: true },
  "/marketing/discounts": { nhan: "Thêm khuyến mãi", quyen: "marketing:write", dich: "/marketing/discounts/new" },
  "/marketing/vouchers": { nhan: "Tạo voucher", quyen: "marketing:write", dich: "/marketing/vouchers/new" },
};

/**
 * Dòng khai của một route — dùng ở TRANG để lấy nhãn/quyền cho hộp thoại.
 *
 * Ném khi chưa khai: trang bày hộp "thêm nhanh" mà route không có trong sổ là hai nguồn sự thật
 * (nút "+" trên menu đọc sổ, hộp gõ tay) — thà vỡ ngay lúc dựng còn hơn lệch âm thầm.
 */
export function khaiThem(href: string): ThemNhanh {
  const t = THEM_NHANH[href];
  if (!t) throw new Error(`Route "${href}" bày hộp thêm-nhanh nhưng chưa khai trong THEM_NHANH`);
  // ⛳ 01/10/2026 — mục khai `dich` là hạng ROUTE RIÊNG: không có hộp nào để lấy `nhan`/`quyen`.
  //    Trang nào gọi hàm này cho nó là đang dựng một hộp thứ hai song song với `/new` — vỡ ngay lúc
  //    dựng, đúng nếp "thà vỡ còn hơn lệch âm thầm" của câu trên.
  if (t.dich)
    throw new Error(
      `Route "${href}" là mục route riêng (khai \`dich\`) — không có hộp thêm-nhanh; form thêm nằm ở "${t.dich}", đừng dựng ThemNhanhModal cho nó`,
    );
  return t;
}

/**
 * Tham số URL đang có — nhận mọi dạng đang lưu hành trong app để nơi gọi khỏi phải tự nắn:
 * `URLSearchParams` (client, `useSearchParams()`), object `searchParams` của server component,
 * hoặc chuỗi truy vấn trần.
 */
export type ThamSoDangCo =
  | URLSearchParams
  | Record<string, string | string[] | undefined>
  | string
  | null
  | undefined;

function chuanHoa(v: ThamSoDangCo): URLSearchParams {
  if (!v) return new URLSearchParams();
  if (typeof v === "string") return new URLSearchParams(v);
  // Dò theo HÌNH DẠNG (`getAll`) chứ không `instanceof URLSearchParams`: `useSearchParams()` trả
  // `ReadonlyURLSearchParams` — cùng hình dạng nhưng qua bản Next khác/bản giả trong test thì
  // `instanceof` có thể trượt, mà trượt ở đây là âm thầm nuốt sạch bộ lọc.
  if (typeof (v as URLSearchParams).getAll === "function")
    return new URLSearchParams((v as URLSearchParams).toString());
  const ra = new URLSearchParams();
  for (const [k, giaTri] of Object.entries(v as Record<string, string | string[] | undefined>)) {
    if (giaTri === undefined) continue;
    for (const x of Array.isArray(giaTri) ? giaTri : [giaTri]) ra.append(k, x);
  }
  return ra;
}

/**
 * Link mở form thêm — CÙNG route danh sách, chỉ **thêm** `them=1` vào những tham số đang có.
 *
 * Cố ý KHÔNG đẻ route `/xxx/new`: trong 141 trang của app chưa có lấy một route "thêm" riêng nào,
 * dựng cái đầu tiên là phải tự chế cả quy ước (quay về đâu sau khi lưu, giữ bộ lọc của danh sách,
 * nút Back trình duyệt). Giữ ở query ⇒ trang danh sách vẫn là trang đang đứng, đóng hộp là xong.
 *
 * ⛳ CẬP NHẬT 17/09/2026 — **route "thêm" riêng ĐẦU TIÊN đã có**: `/inventory/requests/new`. Chữ
 *    trên GIỮ NGUYÊN và vẫn đúng cho hạng HỘP; cái đổi là **hạng kia của luật ⑥ nay mở**: sổ audit
 *    §1b ⑥ chia *form ≤7 trường một bước → hộp* · *form dài / đa bước → route riêng*, và
 *    `RequestForm` (đa dòng, số dòng do người gõ quyết) rơi vào vế thứ hai. An chốt ngày 17/09,
 *    lý do + ba câu quy ước ("quay về đâu", "giữ bộ lọc", "nút Back") trả lời ở đầu
 *    `app/inventory/requests/new/page.tsx` và ở docs/feature/cum-kho-ve-chuan-man-danh-sach.md
 *    §6c hộp ⛳ C1.
 *    🚫 Route đó **cố ý KHÔNG có trong `THEM_NHANH` bên dưới**, vì hai lẽ: ① sổ này là sổ của HỘP
 *      (`khaiThem` lấy `nhan`/`quyen` cho hộp) — route riêng không có hộp nào để lấy; ② route đó
 *      **không có mục menu** ("Phiếu yêu cầu" gỡ khỏi sidebar theo feedback Phương lần 4, xem
 *      `muc-menu.ts`) ⇒ không có chỗ cho nút "+" mọc, dù khai kiểu gì. Khai vào rồi bật `ngoaiMenu`
 *      cho lưới ③ khỏi đỏ chính là cái mà khối 🩸 ở khai báo kiểu đã cấm.
 *    📌 Câu còn ĐỂ NGỎ cho lần sau: hôm nào An cho một màn hạng route-riêng **có mục menu** thì mới
 *      đáng thêm một khoá `href` tuỳ chọn vào `ThemNhanh` để hạng đó dùng chung cơ chế "+". Làm
 *      trước là dựng cơ chế 0 chỗ dùng.
 *
 * ⛳ CẬP NHẬT 01/10/2026 — **"câu để ngỏ" trên ĐÃ ĐÓNG** (vé `nut-them-menu-marketing`, gói 1b audit
 *    cụm Marketing; An chốt Q-b = A). Màn hạng route-riêng có mục menu nay có thật: Khuyến mãi ·
 *    Voucher (`/marketing/discounts/new` · `/marketing/vouchers/new`, gói 1). Khoá thêm vào `ThemNhanh`
 *    tên là **`dich`** (không `href` — `href` đã là khoá của sổ), và nút `+` đọc nó qua **hàm mới
 *    `duongDanNutThem`** ngay dưới. Hàm NÀY giữ nguyên chữ ký và hành vi: nó là hàm của hạng HỘP, có
 *    nút `chinh` của mọi màn hạng hộp + bộ ca T1 đang tin — sửa nó cho trả `dich` là đổi nghĩa một hàm đang
 *    được tin (blueprint vé đó §C.1). Lẽ ① của khối 🚫 trên ("sổ này là sổ của HỘP") vì thế đổi thành
 *    "sổ của NÚT `+` và của hộp" — `khaiThem` ném với mục `dich` để vế hộp vẫn kín. Lẽ ② vẫn nguyên:
 *    `/inventory/requests/new` vẫn không có mục menu ⇒ vẫn KHÔNG khai.
 *
 * 🩸 `hienTai` THÊM 03/09/2026 (T1 của blueprint đợt 1+). Bản pilot trả thẳng `href + "?them=1"`,
 *    tức là **xoá sạch mọi tham số đang có**: nút "Thêm" ở đầu trang `/inventory/receive?branchId=2&q=nhua`
 *    làm mất bộ lọc NGAY LÚC MỞ HỘP, trước cả khi người ta nhập gì. `/referrers` không có bộ lọc nào
 *    nên pilot không lộ. Nút "+" trên MENU vẫn gọi không truyền — đi từ mục menu sang route khác thì
 *    tham số của trang đang đứng không có nghĩa gì ở trang đích.
 */
export const duongDanThem = (href: string, hienTai?: ThamSoDangCo) => {
  const q = chuanHoa(hienTai);
  q.set(THAM_SO_THEM, "1");
  return `${href}?${q.toString()}`;
};

/**
 * Link của NÚT `+` TRÊN MENU — mục route riêng (khai `dich`) đi thẳng tới route đó, mục hạng hộp đi
 * `href?them=1` y như xưa (KHÔNG truyền tham số trang đang đứng — xem 🩸 `hienTai` ở trên).
 *
 * ⛳ THÊM 01/10/2026 (vé `nut-them-menu-marketing`). Chỉ Sidebar gọi; nút `chinh` đầu trang các màn
 *    hạng hộp vẫn gọi `duongDanThem` vì chúng cần `hienTai` (T1 giữ bộ lọc). Đã BỎ: trỏ `+` về
 *    `?them=1` rồi để trang `redirect` sang `/new` — thêm một bước chuyển, và Back quay về `?them=1`
 *    lại bị đẩy đi ⇒ kẹt nút Back.
 */
export const duongDanNutThem = (href: string) => THEM_NHANH[href]?.dich ?? duongDanThem(href);

/**
 * Đường quay về khi ĐÓNG hộp: giữ nguyên mọi tham số, chỉ gỡ đúng khoá `them`. Cặp với hàm trên.
 *
 * 🩸 `khoaKhac` THÊM 06/09/2026 — hộp có thể mở bằng khoá KHÁC `them`, và khoá nào MỞ được thì
 *    đóng phải gỡ luôn, nếu không hộp dựng lại ngay sau `router.replace`. Ca thật: `/appointments`
 *    mở hộp khi có `?patient=…` (11 lối link trong app đi đường đó) ⇒ bấm X / Esc / bấm nền đều
 *    **không đóng được** — URL đổi đúng như lệnh, mà điều kiện mở vẫn còn nguyên.
 *    Trang nào cho thêm cửa mở thì phải khai cửa đó ở đây; đừng để hai chỗ tự biết lấy.
 */
export const duongDanDongThem = (
  pathname: string,
  hienTai?: ThamSoDangCo,
  khoaKhac: readonly string[] = [],
) => {
  const q = chuanHoa(hienTai);
  q.delete(THAM_SO_THEM);
  for (const k of khoaKhac) q.delete(k);
  const s = q.toString();
  return s ? `${pathname}?${s}` : pathname;
};

/** Trang có đang được mở ở chế độ "thêm" không? Dùng ở server component đọc `searchParams`. */
export const dangMoThem = (v: string | undefined) => v === "1";

/**
 * Mục menu này có nút "+" không?
 *
 * ⚖️ `perms` RỖNG = CHƯA BIẾT quyền (app/layout.tsx lấy quyền trong try/catch fail-open rồi truyền
 *    `userPerms ?? []` xuống) → vẫn HIỆN, đúng luật "ngã về phía hiện" của
 *    `components/rbac/ChiKhiCoQuyen.tsx`: một cú lỗi lấy quyền không được phép giấu nút của mọi
 *    người, kể cả Chủ. Đây chỉ là phần NHÌN — rào thật ở `requirePermission()` đầu server action.
 */
export function themNhanhCua(href: string, perms: ReadonlySet<string>): ThemNhanh | null {
  const t = THEM_NHANH[href];
  if (!t) return null;
  // ⛳ 14/09/2026 — `ngoaiMenu`: route khai để lấy `nhan`/`quyen` cho HỘP, nhưng không có mục menu
  //    ⇒ ba cửa menu hỏi hàm này phải nhận `null`, đúng như route chưa khai. Chặn Ở ĐÂY chứ không
  //    ở từng cửa: ba cửa (menu trái · ⌘K · thanh dưới) mà mỗi chỗ tự nhớ một luật là ba chỗ để quên.
  if (t.ngoaiMenu) return null;
  if (perms.size > 0 && !perms.has(t.quyen)) return null;
  // ⛳ 01/10/2026 — `quyenKem`: đòi ĐỦ thêm các quyền này (cùng luật fail-open khi CHƯA BIẾT quyền ở dòng trên).
  if (perms.size > 0 && (t.quyenKem ?? []).some((q) => !perms.has(q))) return null;
  return t;
}
